// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, sans-serif;
}

.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  background: #f4f4f4;
}
.login-logo {
  text-align: center;
  margin-bottom: 10px;
}

.login-logo-img {
  max-width: 100%;
  height: 20%;
}

.login-container {
  display: flex;
  width: 150%;
  position: relative;
  height: 80%;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-left: -30%;
  flex: 10 1;
}

.login-image {
  flex: 12 1;
  background-color: #000;
}

.login-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-form {
  flex: 12 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.error-messages {
  font-size: 14px;
  color: red;
  margin-bottom: 2%;
}

/* Inline error style inside the login modal */
.login-error {
  color: #a70000;
  margin: 16px;
  font-size: 0.95rem;
}

.h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
  text-align: start;
}

.label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.input {
  width: 50%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #333;
  border-radius: 5px;
}

.input:focus {
  border-color: #007bff;
  outline: none;
}

.form-options {
  width: 100%;
  margin: 0 0 20px 0;
  text-align: right;
}

.form-options a {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.btn-login {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #79c42b;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-login:hover {
  background-color: #79c42b;
}

.btn-forgot {
  display: flex;
  justify-content: flex-end;
  background-color: transparent;
  color: #007bff;
  border: none;
  margin: 10px;
  font-size: 14px;
  cursor: pointer;
}

.login-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.login-modal {
  background: white;
  padding: 0;
  border-radius: 8px;
  width: 400px;
  text-align: center;
}

.login-close-button {
  position: absolute;
  top: 20px !important;
  right: 20px !important;

  background-color: transparent !important;
  border: none !important;
  font-size: 30px !important;
  font-weight: bold !important;
  color: rgb(135, 146, 138) !important;
  cursor: pointer !important;
  transition: color 0.3s ease !important;
}

.login-close-button:hover {
  color: rgb(136, 117, 117) !important;
}

.login-modal form input {
  width: 92%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-modal form button {
  width: 100%;
  padding: 10px;
  background-color: #79c42b;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.login-modal form button:hover {
  background-color: #79c42b;
}
.login-modal form button {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.login-modal form button:hover {
  background-color: #45a049;
}
.open-login-btn {
  background-color: #4caf50;
  color: white;
  bottom: 50%;

  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin: 20px;
}

.open-login-btn:hover {
  background-color: #45a049;
}

.btn-open-login {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  position: absolute;
  right: 70px;
  top: 20px;
  z-index: 1000;
  opacity: 0;
  transition:
    opacity 0.3s ease-in-out,
    background-color 0.6s ease-in-out;
}

.btn-open-login:hover {
  background-color: #3e8e41;
  transform: scale(0.98);
}

.btn-open-login:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);
}

.btn-open-login:active {
  background-color: #3e8e41;
  transform: scale(0.98);
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  flex: 1 1;
  padding-right: 2.5em;
}

.toggle-password-icon {
  position: absolute;
  right: 0.5em;
  cursor: pointer;
  font-size: 1.1em;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-icon:hover {
  color: #333;
}

/* Error popup modal */
.error-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.error-modal {
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.error-modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  background: #fff5f5;
  color: #a00;
  font-weight: 600;
}

.error-modal-body {
  padding: 18px 16px;
  color: #333;
  font-size: 14px;
}

.error-modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #f0f0f0;
  background: #fff;
}

.error-modal-ok {
  background: #166279 !important;
  color: white !important;
  border: none !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  font-size: medium !important;
}

@media (max-width: 768px) {
  .login-container {
    width: 100%;
    height: auto;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    border-radius: 0;
  }
  .form-options {
    margin-bottom: 10px;
    text-align: right;
  }
  .login-modal form button {
    width: 112%;
    padding: 10px;
    background-color: #079c40;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
  }

  .login-image {
    display: none;
    flex: 0 1;

    display: block;
    width: 100%;
    height: 200px;
    background-color: #000;
  }

  .login-image img {
    display: none;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .login-form {
    flex: 0 1;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  label {
    font-size: 10px;
    margin-bottom: 3px;
  }

  input {
    width: 100%;
    padding: 6px;
    font-size: 12px;
  }

  .btn-login {
    width: 100%;
  }

  .form-options {
    text-align: center;
  }

  .login-logo-img {
    height: auto;
    max-width: 80%;
  }

  .login-close-button {
    margin-top: 0% !important;
    left: 80% !important;
    font-size: 28px !important;
  }

  .open-login-btn {
    font-size: 14px;
    padding: 8px 20px;
    position: static;
    margin: 12px auto;
    display: block;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 16px;
  }

  label {
    font-size: 10px;
    margin-bottom: 2px;
  }

  input {
    padding: 5px;
    font-size: 11px;
  }

  .btn-login {
    font-size: 12px;
  }

  .login-modal {
    width: 90%;
  }

  .login-image {
    flex: 0 1;
    width: 100%;
    height: 150px;
  }

  .login-form {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;;EAEb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,UAAQ;AACV;;AAEA;EACE,UAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;;EAEtB,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;;EAEX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,UAAU;EACV;;qCAEmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAO;;IAEP,cAAc;IACd,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  font-family: Arial, sans-serif;\n}\n\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n\n  background: #f4f4f4;\n}\n.login-logo {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.login-logo-img {\n  max-width: 100%;\n  height: 20%;\n}\n\n.login-container {\n  display: flex;\n  width: 150%;\n  position: relative;\n  height: 80%;\n  background: #fff;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  overflow: hidden;\n  margin-left: -30%;\n  flex: 10;\n}\n\n.login-image {\n  flex: 12;\n  background-color: #000;\n}\n\n.login-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.login-form {\n  flex: 12;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.error-messages {\n  font-size: 14px;\n  color: red;\n  margin-bottom: 2%;\n}\n\n/* Inline error style inside the login modal */\n.login-error {\n  color: #a70000;\n  margin: 16px;\n  font-size: 0.95rem;\n}\n\n.h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 15px;\n  text-align: start;\n}\n\n.label {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #333;\n}\n\n.input {\n  width: 50%;\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #333;\n  border-radius: 5px;\n}\n\n.input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.form-options {\n  width: 100%;\n  margin: 0 0 20px 0;\n  text-align: right;\n}\n\n.form-options a {\n  color: #007bff;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.btn-login {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  color: #fff;\n  background-color: #79c42b;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.btn-login:hover {\n  background-color: #79c42b;\n}\n\n.btn-forgot {\n  display: flex;\n  justify-content: flex-end;\n  background-color: transparent;\n  color: #007bff;\n  border: none;\n  margin: 10px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.login-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n}\n\n.login-modal {\n  background: white;\n  padding: 0;\n  border-radius: 8px;\n  width: 400px;\n  text-align: center;\n}\n\n.login-close-button {\n  position: absolute;\n  top: 20px !important;\n  right: 20px !important;\n\n  background-color: transparent !important;\n  border: none !important;\n  font-size: 30px !important;\n  font-weight: bold !important;\n  color: rgb(135, 146, 138) !important;\n  cursor: pointer !important;\n  transition: color 0.3s ease !important;\n}\n\n.login-close-button:hover {\n  color: rgb(136, 117, 117) !important;\n}\n\n.login-modal form input {\n  width: 92%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.login-modal form button {\n  width: 100%;\n  padding: 10px;\n  background-color: #79c42b;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n}\n\n.login-modal form button:hover {\n  background-color: #79c42b;\n}\n.login-modal form button {\n  width: 100%;\n  padding: 10px;\n  background-color: #4caf50;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  cursor: pointer;\n}\n\n.login-modal form button:hover {\n  background-color: #45a049;\n}\n.open-login-btn {\n  background-color: #4caf50;\n  color: white;\n  bottom: 50%;\n\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin: 20px;\n}\n\n.open-login-btn:hover {\n  background-color: #45a049;\n}\n\n.btn-open-login {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  text-align: center;\n  text-decoration: none;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n  position: absolute;\n  right: 70px;\n  top: 20px;\n  z-index: 1000;\n  opacity: 0;\n  transition:\n    opacity 0.3s ease-in-out,\n    background-color 0.6s ease-in-out;\n}\n\n.btn-open-login:hover {\n  background-color: #3e8e41;\n  transform: scale(0.98);\n}\n\n.btn-open-login:focus {\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);\n}\n\n.btn-open-login:active {\n  background-color: #3e8e41;\n  transform: scale(0.98);\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  flex: 1;\n  padding-right: 2.5em;\n}\n\n.toggle-password-icon {\n  position: absolute;\n  right: 0.5em;\n  cursor: pointer;\n  font-size: 1.1em;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-password-icon:hover {\n  color: #333;\n}\n\n/* Error popup modal */\n.error-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.error-modal {\n  background: #fff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 420px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.error-modal-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n  background: #fff5f5;\n  color: #a00;\n  font-weight: 600;\n}\n\n.error-modal-body {\n  padding: 18px 16px;\n  color: #333;\n  font-size: 14px;\n}\n\n.error-modal-footer {\n  padding: 12px 16px;\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid #f0f0f0;\n  background: #fff;\n}\n\n.error-modal-ok {\n  background: #166279 !important;\n  color: white !important;\n  border: none !important;\n  padding: 4px 8px !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  font-size: medium !important;\n}\n\n@media (max-width: 768px) {\n  .login-container {\n    width: 100%;\n    height: auto;\n    margin: 0 auto;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    box-shadow: none;\n    border-radius: 0;\n  }\n  .form-options {\n    margin-bottom: 10px;\n    text-align: right;\n  }\n  .login-modal form button {\n    width: 112%;\n    padding: 10px;\n    background-color: #079c40;\n    border: none;\n    border-radius: 4px;\n    color: white;\n    cursor: pointer;\n  }\n\n  .login-image {\n    display: none;\n    flex: 0;\n\n    display: block;\n    width: 100%;\n    height: 200px;\n    background-color: #000;\n  }\n\n  .login-image img {\n    display: none;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .login-form {\n    flex: 0;\n    padding: 0;\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  label {\n    font-size: 10px;\n    margin-bottom: 3px;\n  }\n\n  input {\n    width: 100%;\n    padding: 6px;\n    font-size: 12px;\n  }\n\n  .btn-login {\n    width: 100%;\n  }\n\n  .form-options {\n    text-align: center;\n  }\n\n  .login-logo-img {\n    height: auto;\n    max-width: 80%;\n  }\n\n  .login-close-button {\n    margin-top: 0% !important;\n    left: 80% !important;\n    font-size: 28px !important;\n  }\n\n  .open-login-btn {\n    font-size: 14px;\n    padding: 8px 20px;\n    position: static;\n    margin: 12px auto;\n    display: block;\n  }\n}\n\n@media (max-width: 480px) {\n  h2 {\n    font-size: 16px;\n  }\n\n  label {\n    font-size: 10px;\n    margin-bottom: 2px;\n  }\n\n  input {\n    padding: 5px;\n    font-size: 11px;\n  }\n\n  .btn-login {\n    font-size: 12px;\n  }\n\n  .login-modal {\n    width: 90%;\n  }\n\n  .login-image {\n    flex: 0;\n    width: 100%;\n    height: 150px;\n  }\n\n  .login-form {\n    width: 100%;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
